module.exports = __webpack_public_path__ + "media/images/top/works01-021e9fa162e94e82474dae65c181c22a.jpg";